import React from 'react';
import type {
  FileLocalUrl,
} from 'pages/Dashboard/components/FilePicker';
import WebcamProvider from 'views/EMR/components/WebcamScanDialog/webcamContext';
import WebcamScanContainer from 'views/EMR/components/WebcamScanDialog/WebcamScanContainer';

export type WebcamOutputMode = 'select' | 'images' | 'pdf';

export type WebcamScanDialogProps = {
  limit?: number;
  onCapturedFilesConfirmed?: (files: FileLocalUrl[]) => Promise<void> | void;
  captureType?: string;
  multiple?: boolean;
  outputMode?: WebcamOutputMode;
};

type Props = WebcamScanDialogProps & {
  onClose: () => void;
};
export default function WebcamScanDialog({
  multiple = true,
  outputMode = 'select',
  ...props
}: Props) {
  return (
    <WebcamProvider multiple={multiple} outputMode={outputMode}>
      <WebcamScanContainer {...props} />
    </WebcamProvider>
  );
}
